export default [
  {
    path: '/vendas/venda/novo',
    name: 'storeSaleForm',
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Nova Venda', permission: 'salesCreateEdit' },
    component: () => import('@/views/sales/StoreSaleForm')
  },
  {
    path: '/vendas/venda/editar/:id',
    name: 'updateSale',
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Editar Venda', permission: 'salesCreateEdit' },
    component: () => import('@/views/sales/StoreSaleForm')
  },
  {
    path: '/vendas/devolucao/novo',
    name: 'storeSaleReturning',
    meta: { module: 'sale_returns', write: true, layout: 'appLayout', displayName: 'Nova Devolução', permission: 'salesCreateEdit' },
    component: () => import('@/views/sales/StoreReturningForm')
  },
  {
    path: '/vendas/devolucao/editar/:id',
    name: 'updateSaleReturning',
    meta: { module: 'sale_returns', write: true, layout: 'appLayout', displayName: 'Editar Devolução', permission: 'salesCreateEdit' },
    component: () => import('@/views/sales/StoreReturningForm')
  },
  {
    path: '/vendas/venda/imprimir/:id',
    name: 'printSaleIndex',
    meta: { module: 'sales', layout: 'printLayout', displayName: 'Imprimir Venda', },
    component: () => import('@/views/sales/PrintSaleIndex')
  },
  {
    path: '/vendas/venda/imprimir-orcamento/:id',
    name: 'printProposalIndex',
    meta: { module: 'sales', layout: 'printLayout', displayName: 'Imprimir Orçamento', },
    component: () => import('@/views/sales/PrintProposalIndex')
  },
  {
    path: '/vendas',
    name: 'salesIndex',
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Vendas', icon: 'mdi-cart-variant', permission: 'salesIndex' },
    component: () => import('@/views/sales/SalesIndex')
  },
  {
    path: '/vendas/relatorio-de-vendas-por-marca',
    name: 'sales-by-brand-report',
    meta: { module: 'sales', layout: 'appLayout', displayName: 'Relatório de Vendas Por Marca', icon: 'mdi-cart-variant', permission: 'salesReport' },
    component: () => import('@/views/sales/SalesByBrandReport')
  },
  {
    path: '/comissao',
    name: 'commissionIndex',
    meta: { module: 'commissions', layout: 'appLayout', displayName: 'Comissão', icon: 'mdi-cart-variant', permission: 'commissionIndex' },
    component: () => import('@/views/sales/CommissionIndex')
  },
  {
    path: '/formas-de-pagamento',
    name: 'paymentTermsIndex',
    meta: { layout: 'appLayout', displayName: 'Formas de Pagamento', icon: 'mdi-domain', permission: 'paymentTermsIndex' },
    component: () => import('@/views/sales/PaymentTermsIndex')
  },
  {
    path: '/vendas/relacao-de-produtos',
    name: 'ReportProductsSales',
    meta: {
      module: 'sales', layout: 'appLayout', displayName: 'Relação de Produtos', permission: 'salesIndex'
    },
    component: () => import('@/views/sales/ReportProductsSales.vue')
  },
  {
    path: '/vendas/nova-devolucao-de-produtos/:id',
    name: 'ReturnFromSale',
    meta: {
      module: 'sale_returns', write: true, layout: 'appLayout', displayName: 'Nova Devolução de Produtos', permission: 'salesIndex'
    },
    component: () => import('@/views/sales/ReturnFromSale.vue')
  },
  {
    path: '/vendas/editar-devolucao-de-produtos/:id',
    name: 'EditReturnFromSale',
    meta: {
      module: 'sale_returns', write: true, layout: 'appLayout', displayName: 'Editar Devolução de Produtos', permission: 'salesIndex'
    },
    component: () => import('@/views/sales/ReturnFromSale.vue')
  },

  {
    path: '/pre-vendas',
    name: 'preSalesIndex',
    meta: { module: 'pre_sales', layout: 'appLayout', displayName: 'Pré-Vendas', icon: 'mdi-cart-variant', permission: 'salesIndex' },
    component: () => import('@/views/sales/PreSalesIndex')
  },
]